import { render, staticRenderFns } from "./FolderChangeOwnerDialog.vue?vue&type=template&id=1ddb99ab&scoped=true"
import script from "./FolderChangeOwnerDialog.vue?vue&type=script&lang=js"
export * from "./FolderChangeOwnerDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderChangeOwnerDialog.vue?vue&type=style&index=0&id=1ddb99ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddb99ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAutocomplete,VChip,VIcon})
